export default __webpack_public_path__ + "static/media/gender_violence.9acfda9b.png";